<template>
  <ElButton
    type="danger"
    @click="makeTurkish"
    v-if="!profile.turkish"
  >
    Flag as Turkish Acc.
  </ElButton>
  <ElButton
    type="danger"
    @click="makeTurkish"
    v-else
  >
    Flag as Normal Acc.
  </ElButton>
</template>

<script>
import axios from '@/axios/axios'
import { GlobalEmitter } from '@/utils/GlobalEmitter'

export default {
  name: 'MakeAccountTurkish',
  props: {
    profile: {
      type: Object,
      required: true
    }
  },
  methods: {
    makeTurkish() {
      const data = {
        profileId: this.profile.id,
        turkish: !this.profile.turkish
      }

      return axios.post('admin/make-turkish', data)
        .then(res => {
          if (res.status === 200) {
            this.successNotification(res.data)
            GlobalEmitter.$emit("reloadView")
          } 
          else {
            this.errorNotification("Something went wrong!")
          }
        })
        .catch(axios.handleError)
    }
  }
}
</script>
